import { withGTM } from '@/features/shared/HOCs';
import {
  resolveBool,
  resolveColorName,
  resolveContentBlocks,
  resolveImageReference,
  resolveLink,
  resolveNumber,
  resolveSpacingSize,
} from '@/utils/resolvers';
import React, { memo, useRef } from 'react';
import CMSWrapper from '../shared/CMSWrapper';
import CardCarousel from './CardCarousel';
import { mapTarget, onDatalayer, onDatalayerScroll } from './CardCarousel.datalayer';

const MappedCardCarousel = memo(
  ({ content, presentation, containerTopBackgroundImage, contentButtons }: any) => {
    return (
      <div
        data-datalayer-position="card_carousel"
        data-datalayer-variant={presentation?.datalayerVariant}
        data-component-variant={presentation.template}
      >
        <CardCarousel
          content={content}
          presentation={{ ...presentation, containerTopBackgroundImage }}
          contentButtons={contentButtons}
        />
      </div>
    );
  },
);

const MappedCardCarouselGTMscroll = withGTM({
  Component: MappedCardCarousel,
  onDatalayer: onDatalayerScroll,
  config: {
    eventName: 'gtm:custom:scroll',
    isCustom: true,
  },
});
const MappedCardCarouselGTM = withGTM({
  Component: MappedCardCarouselGTMscroll,
  onDatalayer,
  config: { mapTarget },
});

const CardCarouselCMSWrapper = (brProps: any) => {
  const mapping = useRef({
    document: [
      'content',
      {
        listSuperheading: null,
        listTitle: null,
        cta: [null, resolveLink],
        contentList: [null, resolveContentBlocks],
      },
    ],
    imageDocument: ['containerTopBackgroundImage', resolveImageReference],
    componentParameterMap: [
      'presentation',
      {
        'carousel-template': 'template',
        'card-color': ['cardColor', resolveColorName],
        'text-area-shadow': ['hasTextShadow', resolveBool],
        'background-overlay-opacity': ['backgroundOverlayOpacity', resolveNumber],
        'bottom-spacing': ['containerBottomSpacing', resolveSpacingSize],
        'top-spacing': ['containerTopSpacing', resolveSpacingSize],
        'container-bottom-background-color': ['containerBottomBackgroundColor', resolveColorName],
        'container-top-background-color': ['containerTopBackgroundColor', resolveColorName],
        'variant-label': 'datalayerVariant',
        'hide-cta': ['hideCTA', resolveBool],
        'hide-navigation': ['hideNavigation', resolveBool],
        'content-alignment': 'contentAlignment',
        'drop-shadow': ['hasDropShadow', resolveBool],
        // eslint-disable-next-line prettier/prettier
        autoscroll: ['autoscroll', resolveBool],
        'autoscroll-direction': 'autoscrollDirection',
        'autoscroll-speed': ['autoscrollSpeed', resolveNumber],
        'mobile-stack': ['mobileStacked', resolveBool],
      },
    ],
  });

  const requiredFields = useRef({
    document: '<b>Content</b> required',
  });

  const contentButtonNames = useRef({
    document: 'content',
  });

  return (
    <CMSWrapper
      brProps={brProps}
      render={MappedCardCarouselGTM}
      mapping={mapping.current}
      requiredFields={requiredFields.current}
      contentButtonNames={contentButtonNames.current}
    />
  );
};

export default CardCarouselCMSWrapper;
